const isBrowser = () => {
  return Boolean(globalThis?.document);
};
const scrollToTop = () => {
  if (isBrowser()) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
};

const isMac = () => {
  if (!isBrowser()) return false;
  return navigator.platform.indexOf('Mac') === 0 || navigator.platform === 'iPhone';
};

const getShortcutModifier = () => {
  return isMac() ? '⌘' : '^';
};

export { isBrowser, scrollToTop, getShortcutModifier, isMac };
